import { Vue, Component } from 'vue-property-decorator';
import { IBillingDetail, IBillingApply } from '../billingSystem';
import dateFns from 'date-fns';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
interface IRouteParams {
  type?: string;
  id?: string;
}
@Component({})
export default class Refund extends Vue {
  formatTime(value: number) {
    if (!value) return '-';
    return dateFns.format(value * 1000, 'YYYY-MM-DD HH:mm:ss');
  }
  async checkAmount(id: string) {
    try {
      const {
        data: { invoice_amount },
      } = await window.apis.getInvoiceOrderSingle({
        id: Number(id),
      });

      return Promise.resolve(invoice_amount);
    } catch (error) {
      return Promise.resolve(0);
    }
  }
  handleNoAmountLink(amount: number, toast: string) {
    if (amount <= 0) {
      this.handleRouteLinkTo('billingSystem', {});

      Toast({
        className: 'billing-toast',
        forbidClick: false,
        message: toast,
      });
      return false;
    }
    return true;
  }
  getUrlParams() {
    const { params } = this.$route;
    return { ...params };
  }
  async getInvoiceOrderSingle() {
    const { id, OrderId } = this.getUrlParams();

    const { data } = await window.apis.getInvoiceOrderSingle({
      id: id || OrderId,
    });

    this.getGoodsInfo(data);
  }
  getGoodsInfo(billingDetail: IBillingDetail) {
    this.goodsInfo = {
      goodsName: billingDetail.production_name,
      goodsOrderCode: billingDetail.order_id || billingDetail.id,
      goodsOrderTime: billingDetail.paid_time,
      goodsOrderMoney: billingDetail.pay_amount,
      goodsInvoiceAmount: billingDetail.invoice_amount,
    };
  }
  formatterTax(str: string) {
    // 只输入数字 字母
    const formatStr = str.replace(/[^\w_]/g, '');
    return this.utilHandleStr(formatStr);
  }
  utilHandleStr(str: string) {
    if (!str) return '';
    return str.replace(/[\s]/g, '').replace(/(\w{4})(?=\w)/g, '$1 ');
  }
  handleStrSpace(str: string) {
    if (!str) return '';
    return str.replace(/[\s]/g, '');
  }
  handleRouteLinkTo(name: string, params: IRouteParams): void {
    this.$router.push({
      name,
      params,
    });
  }
  handleLocalstorage(formdata: IBillingApply) {
    window.localStorage.setItem('inputInfo', JSON.stringify(formdata));
  }
  checkEmail(value: string) {
    if (value.indexOf(' ') > -1) return false;
    const mailReg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    // const mailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return mailReg.test(value);
  }

  /**
   * 获取字符长度，中文字符占两位，英文占一位
   * @param str
   * @returns number
   */
  getStrLen(str: string) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  }

  isInteger(num: number) {
    if (!isNaN(num) && num % 1 === 0) {
      return true;
    } else {
      return false;
    }
  }
  transformMoney(val: number) {
    const money: number = val / 100;
    if (!this.isInteger(money)) {
      return money.toFixed(2);
    }

    return money.toFixed() + '.00';
  }
}
